import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, ActivatedRouteSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { Cataloghi } from 'my-lib-sanfelici';
import { SlugService } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-cataloghi-edit',
  templateUrl: './cataloghi-edit.component.html',
  styleUrls: ['./cataloghi-edit.component.css']
})
export class CataloghiEditComponent implements OnInit {
    private url = '/cataloghi/';
    catalogosnap: Observable<Cataloghi>;
    catalogo: Cataloghi;
id: string;
    constructor(
      private slugservice: SlugService,
      private router: Router,
      private route: ActivatedRoute,
      private cataloghiservice: CataloghiService
    ) { }
    submit() {
      this.catalogo.slug = this.slugservice.slug(this.id);
      this.cataloghiservice.update(this.catalogo);
      this.router.navigate(['/cataloghi']);
    }
  ngOnInit() {
      this.id = this.route.snapshot.params['id'];
      this.catalogosnap = this.cataloghiservice.get(this.id);
      this.catalogosnap.subscribe(cat => {
  this.catalogo = cat;
});

  }

}
